
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.',
      image: 'https://public.readdy.ai/ai/img_res/b2fe6c08bd31cf4c110a9bc401ff8470.jpg'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning-Fast Speeds',
      description: 'Experience blazing-fast connection speeds without compromising security. Stream, download, and browse with minimal latency and maximum performance across all your devices.',
      image: 'https://readdy.ai/api/search-image?query=High%20speed%20internet%20connection%20visualization%20with%20glowing%20data%20streams%20and%20network%20lines%20blue%20gradient%20background%20representing%20fast%20VPN%20performance%20modern%20digital%20art%20simple%20clean%20background&width=600&height=400&seq=feature-002&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our extensive network of secure servers located in strategic locations around the world, ensuring reliable connections and optimal performance.',
      image: 'https://readdy.ai/api/search-image?query=World%20map%20with%20glowing%20connection%20points%20and%20network%20nodes%20representing%20global%20VPN%20server%20locations%20blue%20and%20purple%20colors%20modern%20tech%20visualization%20clean%20simple%20background%20high%20quality&width=600&height=400&seq=feature-003&orientation=landscape'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and anonymous with our strict no-logs policy and privacy-first approach.',
      image: 'https://readdy.ai/api/search-image?query=Privacy%20protection%20concept%20with%20invisible%20shield%20and%20anonymous%20user%20symbols%20dark%20blue%20background%20representing%20no%20logs%20policy%20modern%20security%20illustration%20clean%20simple%20design&width=600&height=400&seq=feature-004&orientation=landscape'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Our VPN works seamlessly across Windows, Mac, iOS, Android, and Linux platforms with easy-to-use applications.',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20including%20smartphone%20tablet%20laptop%20connected%20together%20with%20security%20shield%20blue%20gradient%20background%20representing%20multi%20platform%20VPN%20support%20modern%20tech%20illustration%20simple%20clean%20background&width=600&height=400&seq=feature-005&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is available around the clock to assist you with any questions or technical issues, ensuring you always have help when you need it.',
      image: 'https://readdy.ai/api/search-image?query=Customer%20support%20representative%20with%20headset%20helping%20users%20friendly%20professional%20atmosphere%20blue%20and%20white%20colors%20modern%20service%20illustration%20clean%20simple%20background%20high%20quality&width=600&height=400&seq=feature-006&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Powerful Features for Complete Protection
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our VPN application combines advanced security features with user-friendly design to deliver the ultimate privacy protection experience
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
